import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { LOGO_SRC } from "@/components/brand/Logo";

const SPLASH_MS = 1000;

export const LoadingScreen = () => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const t = setTimeout(() => setVisible(false), SPLASH_MS);
    return () => clearTimeout(t);
  }, []);

  return (
    <AnimatePresence>
      {visible && (
        <motion.div
          className="splash"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] } }}
          role="status"
          aria-live="polite"
          aria-label="Loading KINGBULLISH"
          data-testid="loading-screen"
        >
          <motion.div className="splash__inner" exit={{ scale: 1.06, transition: { duration: 0.4, ease: [0.22, 1, 0.36, 1] } }}>
            <div className="splash__scene" aria-hidden="true">
              <span className="splash__ring splash__ring--1" />
              <span className="splash__ring splash__ring--2" />
              <span className="splash__wave" />
              <span className="splash__wave splash__wave--2" />
              <span className="splash__crown-glow" />
              <img src={LOGO_SRC} alt="" className="splash__logo" width={160} height={160} decoding="async" data-testid="loading-screen-logo" />
            </div>
            <div className="splash__brand" data-testid="loading-screen-brand">
              KING<span>BULLISH</span>
            </div>
            <div className="splash__tagline" data-testid="loading-screen-tagline">INVEST IN THE FUTURE</div>
            <span className="splash__bar" aria-hidden="true"><span /></span>
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
